import React from 'react';
import { Link } from 'react-router-dom';
import {
    cartItemTypeIdsThatCanBeDirectlyAddedToCart,
    cartItemTypeIdsWithoutProductDetailsPage,
    cartItemTypeIdsWithoutDisplayingPartNumber,
} from '../../../models/constants';
import AddToCart from '../../common/add-to-cart';
import { IProduct } from '../../../models/product-list';
import { IOrderDetails } from '../../../models/product-detail';
import { useIntl } from 'react-intl';
import ToolTipAnchor from '../../common/tooltip';
import {
    useHandleToggleFavorite,
    useIsFavorite,
} from '../../../hooks/use-is-favorite';
import { getShippingLabelPDF } from '../../../api/shipping-label-api';
import { apiOpenPDF } from '../../../api/api-utils';
interface IProductItemProps {
    product: IProduct;
    productDetailUrl: string;
    maxQuantity: number;
    onGoToProductDetail: (e: any) => void;
    addToCart: (order: IOrderDetails) => Promise<boolean>;
    selectedAgreement: string;
    country: string;
}

const ProductItem = ({
    product,
    productDetailUrl,
    maxQuantity,
    onGoToProductDetail,
    addToCart,
    selectedAgreement,
    country,
}: IProductItemProps) => {
    const intl = useIntl();

    const getFileName = (url: string) => {
        if (url) {
            const m = url.match(/.*\/(.+?)\./);
            if (m && m.length > 1) {
                return m[1];
            }
        }
        return '';
    };

    const getProductPDF = async (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
        e.preventDefault();
        const result = await getShippingLabelPDF(product.documentLink);
        apiOpenPDF(result);
    };

    const isFavorite = useIsFavorite();
    const handleToggleFavorite = useHandleToggleFavorite();

    return (
        <>
            <div
                style={{
                    textAlign: 'center',
                    margin: '20px',
                    border: '1px solid lightgrey',
                    flexBasis: '29%', // added for IE 11 support
                }}
            >
                {cartItemTypeIdsWithoutProductDetailsPage.includes(
                    product.cartItemTypeId
                ) ? (
                    <img
                        alt={product.description}
                        style={{
                            width: '160px',
                            height: '160px',
                            paddingTop: '5px',
                        }}
                        src={product.imageUrl}
                    />
                ) : (
                    <Link to={productDetailUrl} onClick={onGoToProductDetail}>
                        <img
                            alt={product.description}
                            style={{
                                width: '160px',
                                height: '160px',
                                paddingTop: '5px',
                            }}
                            src={product.imageUrl}
                        />
                    </Link>
                )}

                <div
                    className="row"
                    style={{
                        width: '280px',
                        border: '0px solid black',
                        margin: '0px',
                    }}
                >
                    <div
                        className="col-md-10"
                        style={{
                            textAlign: 'left',
                            border: '0px solid black',
                        }}
                    >
                        {cartItemTypeIdsWithoutProductDetailsPage.includes(
                            product.cartItemTypeId
                        ) ? (
                            <h3
                                style={{
                                    fontSize: '18px',
                                    textTransform: 'none',
                                }}
                            >
                                {product.description}
                            </h3>
                        ) : (
                            <Link
                                to={productDetailUrl}
                                onClick={onGoToProductDetail}
                            >
                                <h3
                                    style={{
                                        fontSize: '18px',
                                        textTransform: 'none',
                                    }}
                                >
                                    {product.description}
                                </h3>
                            </Link>
                        )}
                        {!cartItemTypeIdsWithoutDisplayingPartNumber.includes(
                            product.cartItemTypeId
                        ) && (
                            <div style={{ display: 'flex' }}>
                                <h4 className="product-list">
                                    {product.defaultProductNumber ||
                                        product.partNumber}
                                </h4>
                                {product.manufacturerItem && (
                                    <span>
                                        <ToolTipAnchor
                                            toolTipMessage={intl.formatMessage({
                                                id: product.manufacturerItem,
                                                defaultMessage:
                                                    product.manufacturerItem,
                                            })}
                                        />
                                    </span>
                                )}
                            </div>
                        )}
                        {product.gain && (
                            <h4 className="product-list">
                                {intl.formatMessage({
                                    id: 'Gain',
                                    defaultMessage: 'Gain',
                                }) +
                                    ': ' +
                                    product.gain}
                            </h4>
                        )}
                        {product.documentLink && (
                            <h4 className="product-list">
                                <a
                                    onClick={(e) => getProductPDF(e)}
                                    className="product-list"
                                    href="#"
                                    download={getFileName(product.documentLink)}
                                >
                                    {intl.formatMessage({
                                        id: 'Download_PDF',
                                        defaultMessage: 'Download PDF',
                                    })}
                                </a>
                            </h4>
                        )}
                    </div>
                    <div
                        className="col-md-2"
                        style={{
                            textAlign: 'left',
                            padding: '0px',
                            border: '0px solid black',
                        }}
                    >
                        <button
                            type="button"
                            style={{
                                borderStyle: 'solid',
                                borderColor: 'transparent',
                                backgroundColor: 'transparent',
                            }}
                            title={
                                isFavorite(product.id)
                                    ? intl.formatMessage({
                                          id: 'Remove_Favorite',
                                          defaultMessage: 'Remove Favorite',
                                      })
                                    : intl.formatMessage({
                                          id: 'Add_Favorite',
                                          defaultMessage: 'Add Favorite',
                                      })
                            }
                            onClick={() => {
                                handleToggleFavorite(product.id);
                            }}
                        >
                            <i
                                className={
                                    isFavorite(product.id)
                                        ? 'fas fa-star fa-lg'
                                        : 'far fa-star fa-lg'
                                }
                            />
                        </button>
                    </div>
                </div>
                {product.apCompatibility && (
                    <div style={{ padding: '5px' }}>
                        <span>
                            <p>{product.apCompatibility}</p>
                        </span>
                    </div>
                )}
                {cartItemTypeIdsThatCanBeDirectlyAddedToCart.includes(
                    product.cartItemTypeId
                ) && (
                    <div
                        style={{
                            margin: '0px 35px 20px 35px',
                        }}
                    >
                        <AddToCart
                            productId={product.id}
                            cartItemTypeId={product.cartItemTypeId}
                            partNumber={product.partNumber}
                            maxQuantity={maxQuantity}
                            productUrl={product.url}
                            addToCart={addToCart}
                            selectedAgreement={selectedAgreement}
                            country={country}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default ProductItem;
